<div class="initial-form-container">
  <!-- Error messages -->
  @if (errorMessages.length > 0) {
    <div class="alert alert-danger">
      @for (msg of errorMessages; track $index) {
        <div>{{ msg }}</div>
      }
    </div>
  }

  <!-- Success message -->
  @if (successMessage) {
    <div class="alert alert-success">{{ successMessage }}</div>
  }

  <!-- Library form component. Initial Form is always view-only — viewMode=true
       forces the library to suppress its action area entirely, and an empty
       availableActions array is belt-and-braces against any future regression. -->
  <fb-bs-generic-formly-form
    [formDefinition]="formDefinition"
    [formData]="model"
    [viewMode]="true"
    [requestTypeLogicalId]="requestTypeLogicalId"
    [requestId]="requestId ? +requestId : undefined"
    [availableActions]="[]"
    (formSubmit)="onFormSubmit($event)">
  </fb-bs-generic-formly-form>
</div>
